import extend from "../../services/extend";

/**
 * @ngdoc directive
 * @name vIntersect
 * This will watch if a element enters viewport
 */

export default (vue) => extend(vue, (vue) => {

    if (!("IntersectionObserver" in window)) {
        return false;
    }

    let intersect = new IntersectionObserver((entries) => {
        entries.forEach((entry) => {
            if ( entry.intersectionRatio > 0 ) {
                intersect.unobserve(entry.target);
                vue.set(vue.exp, true);
            }
        });
    });

    intersect.observe(vue.el);

});